module.exports = __webpack_public_path__ + "img/arrow-down-blue.918e029f.svg";